import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import logoImg from '../assets/logo.jpeg';
import { defaultContent } from '../lib/defaultContent';

export default function Footer({ content }) {
  const logo = content?.logo || defaultContent.global.logo;
  const footerAboutText = content?.footerAboutText || defaultContent.global.footerAboutText;
  const currentContactInfo = content?.contactInfo || defaultContent.global.contactInfo;
  const currentFooterLinks = content?.footerLinks || defaultContent.global.footerLinks;
  const currentSocialLinks = content?.socialLinks || defaultContent.global.socialLinks;

  return (
    <footer className="bg-black text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-8">
              <img 
                src={logo.image}
                alt="Logo" 
                className="w-12 h-12 rounded-full border-2 border-brand-rose"
              />
              <span className="font-bold text-2xl tracking-tight text-sand-100" style={{ fontFamily: "'Comic Sans MS', 'Chalkboard SE', 'Comic Neue', sans-serif" }}>{logo.text}</span>
            </Link>
            <p className="text-sand-100 text-sm max-w-sm mb-8 leading-relaxed">
              {footerAboutText}
            </p>
            <div className="flex space-x-4">
              {currentSocialLinks.map((social, i) => {
                const Icon = FiIcons[social.iconName] || FiIcons.FiStar;
                return (
                <a key={i} href={social.url} className="w-10 h-10 rounded-full border border-sand-200/20 flex items-center justify-center hover:bg-brand-red hover:border-transparent transition-all">
                  <SafeIcon icon={Icon} className="w-5 h-5" />
                </a>
              )})}
            </div>
          </div>
          
          <div>
            <h3 className=" font-bold text-lg mb-6 text-sand-100">Practice</h3>
            <ul className="space-y-4 text-sm text-sand-100">
              {currentFooterLinks.map((link, idx) => (
                <li key={idx}><Link to={link.path} className="hover:text-sand-100 transition-colors">{link.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className=" font-bold text-lg mb-6 text-sand-100">Contact</h3>
            <ul className="space-y-4 text-sm text-sand-100">
              {currentContactInfo.map((info, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="font-bold text-sand-100">{info.prefix}</span>
                  {info.text}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-20 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-sand-100/60">
          <p>&copy; {new Date().getFullYear()} The Unraveled Parent&trade;. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/admin" className="hover:text-sand-100">Admin</Link>
            <a href="#" className="hover:text-sand-100">Privacy Policy</a>
            <a href="#" className="hover:text-sand-100">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}